
import { createAction, createSlice } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';

import type { Contractor } from './../lib/types';
import { contractorApi } from './../lib/api';
import type { AppState } from './redux';

export const FETCH_CONTRACTOR = 'vehicles/contractor/fetch';
export const UPDATE_CONTRACTOR = 'vehicles/contractor/update';
export const CLEAN_CONTRACTOR = 'vehicles/contractor/clean';

export type ContractorState = Contractor | null;

const initialState: ContractorState = null;

const fetchContractorAction = createAction<Contractor>(FETCH_CONTRACTOR);
const updateContractorAction = createAction<Contractor>(UPDATE_CONTRACTOR);
const cleanContractorAction = createAction(CLEAN_CONTRACTOR);

const contractorSlice = createSlice({
  name: 'contractor',
  initialState: initialState as ContractorState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchContractorAction, (state, { payload }) => ({ ...payload }))
      .addCase(updateContractorAction, (state, { payload }) => ({ ...payload }))
      .addCase(cleanContractorAction, () => null);
  }
});

export const contractorActions = {
  fetch: fetchContractorAction,
  update: updateContractorAction,
  clean: cleanContractorAction
};

export const addContractor = (contractor: Contractor) => async (
  dispatch: Dispatch
): Promise<void> => {
  await contractorApi.addContractor(contractor);
};

export const updateContractor = (contractor: Contractor) => async (
  dispatch: Dispatch
): Promise<void> => {
  const updated = await contractorApi.updateContractor(contractor);
  dispatch(contractorActions.update({ ...updated }));
};

export const fetchContractor = (id: number) => async (dispatch: Dispatch) => {
  const contractor = await contractorApi.fetchContractor(id);
  dispatch(contractorActions.fetch({ ...contractor }));
};

export const cleanContractor = () => (dispatch: Dispatch) =>
  dispatch(contractorActions.clean());

export default contractorSlice.reducer;
